// extracted by mini-css-extract-plugin
module.exports = {"menu":"Auth-nav_menu__1a_3S"};